import ui from './ui';

export default {
	ui
};
